import React, { useState, useEffect } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';

const DataFiliale = (props) => {
    const [filialen, setFilialen] = useState([]);

    useEffect(() => {
        const storedFilialen = props.filialeList;
        setFilialen(storedFilialen || []);
    }, [props.filialeList]);

    const handleChangeFiliale = (event) => {
        const filiale = event.target.dataset.filiale;
       //console.log('onChangeFiliale', filiale);
        props.onChangeFiliale(filiale);
    };

   //console.log(props.valueFiliale, filialen);

    if (filialen[props.valueFiliale] && filialen[props.valueFiliale].bezeichnung !== undefined) {
        //const filiale = filialen[valueFiliale];
        //console.log('DataFiliale', filialen, filiale, valueFiliale);
        return (
            <NavDropdown title={filialen[props.valueFiliale].bezeichnung} id="basic-nav-dropdown" bg="dark" data-bs-theme="dark" style={{ color: 'var(--bs-navbar-color)' }}>
                <NavDropdown.Item>Bitte wählen</NavDropdown.Item>
                <NavDropdown.Divider />
                {filialen.map((element, i) => {
                    if (element['nr'] > 0) {
                        return (
                            <NavDropdown.Item
                                key={i}
                                onClick={handleChangeFiliale}
                                data-filiale={element['nr']}
                            >
                                {element['bezeichnung']}
                            </NavDropdown.Item>
                        );
                    } else {
                        return null;
                    }
                })}
            </NavDropdown>
        );
    } else {
       //console.log('DataFiliale false', filialen[props.valueFiliale], filialen, props.valueFiliale);
        return <>false</>;
    }
};

export default DataFiliale;